import { useEffect } from 'react';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useUserContext } from '@/contexts/UserContext/UserContext';

export const AlertNotification = ({ tId, retryFn }: { tId: string | undefined; retryFn?: () => void }) => {
  const { updateUserContext } = useUserContext();
  const { opened, setOpened, toggleDialog } = useDialog();

  useEffect(() => {
    if (tId) {
      setOpened(true);
    }
  }, [tId]);

  const handleRetry = () => {
    retryFn?.();
    setOpened(false);
    updateUserContext({ alertNotification: undefined });
  };

  if (!tId) {
    return null;
  }

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      Title={<Text tId={'ERROR'} />}
      onSubmit={handleRetry}
      Description={<Text tId={tId} />}
      MainButton={<Text tId={'RETRY'} />}
    />
  );
};
